import React from 'react';
import './TotalizadoresFacturas.css';

const formatMontoArgentino = (monto) => {
  const valor = Number(monto) || 0;
  return `$${valor.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const TotalizadoresFacturas = ({ totalFacturas = 0, montoTotal = 0 }) => {
  return (
    <div className="totalizadores-facturas" role="region" aria-label="Totalizadores de facturas">
      <div className="totalizadores-facturas-card" aria-label={`Total: ${totalFacturas} facturas`}>
        <span className="totalizadores-facturas-label">Total Facturas</span>
        <span className="totalizadores-facturas-valor">{totalFacturas} {totalFacturas === 1 ? 'factura' : 'facturas'}</span>
      </div>
      <div className="totalizadores-facturas-card" aria-label={`Monto total: ${formatMontoArgentino(montoTotal)}`}>
        <span className="totalizadores-facturas-label">Monto Total</span>
        <span className="totalizadores-facturas-valor">{formatMontoArgentino(montoTotal)}</span>
      </div>
    </div>
  );
};

export default TotalizadoresFacturas;
